import styled from 'styled-components'
import {ContentContainer, Button} from '@components/lib'

export const LogoLink = styled.a`
  display: flex;
  align-items: center;
`

export const Logospan = styled.div``

export const NavItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Wrapper = styled.header`
  height: 70px;
  display: flex;
  align-items: center;
  width: 100%;
  ${({theme}) => theme.breakpoints.down('tablet')} {
    border-bottom: 1px solid ${({theme}) => theme.colors.border};
  }
`

export const Container = styled(ContentContainer)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const RightButton = styled(Button)`
  margin-left: 15px;
  text-transform: uppercase;
`
